import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import { API_BASE } from "../config";
import { authHeaders } from "../utils/authHeaders";

export default function FpoMaster() {
  const [fpos, setFpos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [blocks, setBlocks] = useState([]);

  const [selectedStateId, setSelectedStateId] = useState("");
  const [selectedDistrictId, setSelectedDistrictId] = useState("");
  const [selectedBlockId, setSelectedBlockId] = useState("");

  const [form, setForm] = useState({
    name: "",
    state: "",
    district: "",
    block: "",
    registration_no: "",
  });

  const loadFpos = async () => {
    setLoading(true);
    setMessage("");

    try {
      const res = await fetch(`${API_BASE}/fpos`, {
        headers: authHeaders(),
      });

      const data = await res.json();

      if (!res.ok || data.success === false) {
        throw new Error(data.message || "Failed to load FPOs");
      }

      setFpos(Array.isArray(data.data) ? data.data : []);
    } catch (err) {
      console.error("Load FPOs error:", err);
      setMessage(err.message || "Failed to load FPOs");
    } finally {
      setLoading(false);
    }
  };

  const loadStates = async () => {
    try {
      const res = await fetch(`${API_BASE}/geography/states`, {
        headers: authHeaders(),
      });
      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Failed to load states");
      }

      setStates(Array.isArray(data.data) ? data.data : []);
    } catch (err) {
      console.error("Load states error:", err);
    }
  };

  const loadDistricts = async (stateId) => {
    setDistricts([]);
    setBlocks([]);
    setSelectedDistrictId("");
    setSelectedBlockId("");

    if (!stateId) return;

    try {
      const res = await fetch(
        `${API_BASE}/geography/districts?state_id=${stateId}`,
        {
          headers: authHeaders(),
        }
      );
      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Failed to load districts");
      }

      setDistricts(Array.isArray(data.data) ? data.data : []);
    } catch (err) {
      console.error("Load districts error:", err);
    }
  };

  const loadBlocks = async (districtId) => {
    setBlocks([]);
    setSelectedBlockId("");

    if (!districtId) return;

    try {
      const res = await fetch(
        `${API_BASE}/geography/blocks?district_id=${districtId}`,
        {
          headers: authHeaders(),
        }
      );
      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Failed to load blocks");
      }

      setBlocks(Array.isArray(data.data) ? data.data : []);
    } catch (err) {
      console.error("Load blocks error:", err);
    }
  };

  useEffect(() => {
    loadFpos();
    loadStates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!form.name.trim()) {
      setMessage("FPO name is required");
      return;
    }

    try {
      const res = await fetch(`${API_BASE}/fpos`, {
        method: "POST",
        headers: authHeaders({
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(form),
      });

      const data = await res.json();

      if (!res.ok || data.success === false) {
        throw new Error(data.message || "Failed to create FPO");
      }

      setMessage("FPO created successfully");

      setForm({
        name: "",
        state: "",
        district: "",
        block: "",
        registration_no: "",
      });

      setSelectedStateId("");
      setSelectedDistrictId("");
      setSelectedBlockId("");
      setDistricts([]);
      setBlocks([]);

      loadFpos();
    } catch (err) {
      console.error("Create FPO error:", err);
      setMessage(err.message || "Failed to create FPO");
    }
  };

  return (
    <div style={{ display: "flex" }}>
      <Sidebar />

      <div style={{ padding: 24, width: "100%" }}>
        <h2>FPO Master</h2>

        <p style={{ color: "#555" }}>
          Super Admin can create and view FPOs here.
        </p>

        {message && (
          <div
            style={{
              marginBottom: 16,
              padding: 10,
              background: "#f5f5f5",
              border: "1px solid #ddd",
            }}
          >
            {message}
          </div>
        )}

       <form
  onSubmit={handleCreate}
  style={{
    display: "grid",
    gridTemplateColumns: "1.4fr 1fr 1fr 1fr 1.4fr auto",
    gap: "12px",
    alignItems: "end",
    marginBottom: 24,
  }}
>
  <div>
    <label style={{ display: "block", marginBottom: 6 }}>FPO Name *</label>
    <input
      name="name"
      value={form.name}
      onChange={handleChange}
      placeholder="FPO Name"
      style={{
        width: "100%",
        height: 40,
        padding: "8px 10px",
        border: "1px solid #999",
        borderRadius: 4,
        boxSizing: "border-box",
      }}
    />
  </div>

  <div>
    <label style={{ display: "block", marginBottom: 6 }}>State</label>
    <select
      value={selectedStateId}
      onChange={(e) => {
        const stateId = e.target.value;
        setSelectedStateId(stateId);

        const selected = states.find(
          (s) => String(s.id) === String(stateId)
        );

        setForm((prev) => ({
          ...prev,
          state: selected?.name || "",
          district: "",
          block: "",
        }));

        loadDistricts(stateId);
      }}
      style={{
        width: "100%",
        height: 40,
        padding: "8px 10px",
        border: "1px solid #999",
        borderRadius: 4,
        boxSizing: "border-box",
      }}
    >
      <option value="">Select State</option>
      {states.map((s) => (
        <option key={s.id} value={s.id}>
          {s.name}
        </option>
      ))}
    </select>
  </div>

  <div>
    <label style={{ display: "block", marginBottom: 6 }}>District</label>
    <select
      value={selectedDistrictId}
      disabled={!selectedStateId}
      onChange={(e) => {
        const districtId = e.target.value;
        setSelectedDistrictId(districtId);

        const selected = districts.find(
          (d) => String(d.id) === String(districtId)
        );

        setForm((prev) => ({
          ...prev,
          district: selected?.name || "",
          block: "",
        }));

        loadBlocks(districtId);
      }}
      style={{
        width: "100%",
        height: 40,
        padding: "8px 10px",
        border: "1px solid #999",
        borderRadius: 4,
        boxSizing: "border-box",
      }}
    >
      <option value="">Select District</option>
      {districts.map((d) => (
        <option key={d.id} value={d.id}>
          {d.name}
        </option>
      ))}
    </select>
  </div>

  <div>
    <label style={{ display: "block", marginBottom: 6 }}>Block</label>
    <select
      value={selectedBlockId}
      disabled={!selectedDistrictId}
      onChange={(e) => {
        const blockId = e.target.value;
        setSelectedBlockId(blockId);

        const selected = blocks.find(
          (b) => String(b.id) === String(blockId)
        );

        setForm((prev) => ({
          ...prev,
          block: selected?.name || "",
        }));
      }}
      style={{
        width: "100%",
        height: 40,
        padding: "8px 10px",
        border: "1px solid #999",
        borderRadius: 4,
        boxSizing: "border-box",
      }}
    >
      <option value="">Select Block</option>
      {blocks.map((b) => (
        <option key={b.id} value={b.id}>
          {b.name}
        </option>
      ))}
    </select>
  </div>

  <div>
    <label style={{ display: "block", marginBottom: 6 }}>
      Registration No.
    </label>
    <input
      name="registration_no"
      value={form.registration_no}
      onChange={handleChange}
      placeholder="Registration No."
      style={{
        width: "100%",
        height: 40,
        padding: "8px 10px",
        border: "1px solid #999",
        borderRadius: 4,
        boxSizing: "border-box",
      }}
    />
  </div>

  <button
    type="submit"
    style={{
      height: 40,
      padding: "0 20px",
      background: "#1976D2",
      color: "#fff",
      border: "none",
      borderRadius: 4,
      cursor: "pointer",
      whiteSpace: "nowrap",
    }}
  >
    Create
  </button>
</form>

        <h3>FPO List</h3>

        {loading ? (
          <p>Loading...</p>
        ) : (
          <table
            border="1"
            cellPadding="8"
            cellSpacing="0"
            style={{ borderCollapse: "collapse", width: "100%" }}
          >
            <thead>
              <tr style={{ background: "#f0f0f0" }}>
                <th>ID</th>
                <th>Name</th>
                <th>State</th>
                <th>District</th>
                <th>Block</th>
                <th>Registration No.</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {fpos.length === 0 ? (
                <tr>
                  <td colSpan="7" style={{ textAlign: "center" }}>
                    No FPO found
                  </td>
                </tr>
              ) : (
                fpos.map((fpo) => (
                  <tr key={fpo.id}>
                    <td>{fpo.id}</td>
                    <td>{fpo.name}</td>
                    <td>{fpo.state || "-"}</td>
                    <td>{fpo.district || "-"}</td>
                    <td>{fpo.block || "-"}</td>
                    <td>{fpo.registration_no || "-"}</td>
                    <td>{fpo.is_active ? "Active" : "Inactive"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}